import { FC } from 'react';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

// import { CommonCardImage } from '@/components/common/CommonCardImage';
import { ButtonLink } from '@/components/buttons/ButtonLink';
import { DateFormat } from '@/components/common/DateFormat';
import { AnimatedCard } from '@/components/animation/AnimatedCard';

import { CommonCardProps } from './CommonCard.props';
import { useCommonImageSizePicker } from '@/hooks';

export const CommonCard: FC<CommonCardProps> = ({
  title,
  linkText,
  commonImage,
  date,
  content,
  className,
  linkUrl = '/',
  isInnerLink = false,
  ariaLabel = 'Перейти на сторінку',
  isNews = false,
}) => {
  const { width, height } = useCommonImageSizePicker();

  return (
    <AnimatedCard
      className={cn(
        'flex flex-col rounded p-4 shadow-base dark:border dark:border-darkFullLight md:min-h-full',
        className,
      )}
    >
      <div className="mb-5 aspect-[1.5/1] w-full overflow-hidden rounded bg-gradient-to-b from-grStart to-grEnd bg-cover bg-center object-contain object-center md:aspect-auto md:h-[194px]">
        {isInnerLink ? (
          <Link href={linkUrl} aria-label={ariaLabel} prefetch={false}>
            <Image
              src={commonImage?.mediaItemUrl ?? '/images/image-bg.jpg'}
              alt={commonImage?.altText ?? 'image not found'}
              width={width}
              height={height}
              className="h-full w-full rounded object-cover object-center"
            />
          </Link>
        ) : (
          <a
            href={linkUrl}
            target="_blank"
            rel="noreferrer noopener nofollow"
            aria-label={ariaLabel}
          >
            <Image
              src={commonImage?.mediaItemUrl ?? '/images/image-bg.jpg'}
              alt={commonImage?.altText ?? 'image not found'}
              width={width}
              height={height}
              className="h-full w-full rounded object-cover object-center"
            />
          </a>
        )}
      </div>
      <p className="!mb-4 text-md">
        <DateFormat date={date} />
      </p>
      <div className="flex flex-grow flex-col justify-between">
        {isNews ? (
          <p className="mb-4 line-clamp-2 text-xl font-bold md:text-xxl">
            {title}
          </p>
        ) : (
          <p className="card-title mb-4 line-clamp-2 text-xl font-bold md:text-xxl">
            {title}
          </p>
        )}
        <div
          className="card-excerpt mb-4 line-clamp-6 flex-grow text-base lg:line-clamp-5"
          dangerouslySetInnerHTML={{ __html: content }}
        />

        <div className="flex items-end justify-end">
          <ButtonLink
            withIcon
            href={linkUrl}
            isInnerLink={isInnerLink}
            aria-label={ariaLabel}
          >
            {linkText}
          </ButtonLink>
        </div>
      </div>
    </AnimatedCard>
  );
};
